export default __webpack_public_path__ + "static/media/ttg-icon.dd11da52.webp";